import { QFilter, Supporter } from '@/types';
import OtherActionsPanelLayout from '@components/OtherActionsPanelContent/shared/OtherActionsPanelLayout';
import { useOtherActionsPanelForm } from '@components/OtherActionsPanelContent/shared/useOtherActionsPanelForm';
import { useOtherActionsPanelList } from '@components/OtherActionsPanelContent/shared/useOtherActionsPanelList';
import { useOtherActionsPanelQFilterApply } from '@components/OtherActionsPanelContent/useOtherActionsPanelQFilterApply';

export {
  GROUP_OVERLAP_MESSAGE,
  GROUP_NAMES_TOO_SHORT,
  GROUP_NAMES_REPEAT,
  TAG_OVERLAP_MESSAGE,
  TASK_CHOICE_MAPPING_WITH_IDS,
  TASK_KIND_MAPPING_WITH_IDS,
  UPDATE_PATHWAY_OPTIONS,
} from '@components/OtherActionsPanelContent/shared/otherActionsPanelConstants';

interface OtherActionsPanelContentProps {
  onClose: (isSuccessful: boolean) => void;
  qFilter: QFilter;
  sortOrder?: string;
  sortColumn?: string;
  listId?: number;
  listCount?: number;
  selectedContacts?: Supporter[];
}

export default function OtherActionsPanelContent({
  onClose: handleClose,
  qFilter,
  sortOrder = 'asc',
  sortColumn = 'id',
  listCount = 0,
  listId = 0,
  selectedContacts,
}: OtherActionsPanelContentProps) {
  const { otherActionList, ACCORDION_STARTING_STATE } = useOtherActionsPanelList();
  const form = useOtherActionsPanelForm({
    accordionStartingState: ACCORDION_STARTING_STATE,
    listId,
    sortColumn,
    sortOrder,
    contactIds: qFilter.contactIds,
    selectedContacts,
  });
  const { applyLoading, handleApply } = useOtherActionsPanelQFilterApply({
    form,
    qFilter,
    listId,
    sortOrder,
    sortColumn,
    onClose: handleClose,
  });

  return (
    <OtherActionsPanelLayout
      form={form}
      otherActionList={otherActionList}
      listId={listId}
      listCount={listCount}
      sortOrder={sortOrder}
      sortColumn={sortColumn}
      contactIds={qFilter.contactIds}
      selectedContacts={selectedContacts}
      applyLoading={applyLoading}
      onApply={handleApply}
      onCancel={() => {
        form.resetInternalState();
        handleClose(false);
      }}
      largeSelectionWarning={(qFilter.contactIds ?? []).length > 500}
    />
  );
}
